<template>
  <div class="mt-2">
    <h3 class="text-primary py-2 text-center">Application Volume and Trend Analysis Charts - Oct 25 to Sep 26</h3>
    <CRow>
        <CCol md="6">
            <MonthlyChart />
        </CCol>
        <CCol md="6">
            <SpecialityChart />
        </CCol>
        <CCol md="6">
            <RankedChart />
        </CCol>
        <CCol md="6">
            <ApplicationTrendChart />
        </CCol>
        <CCol md="6">
            <CandidateVolumnOTM />
        </CCol>
        <CCol md="6">
            <ForecastingChart />
        </CCol>
      </CRow>
      <div>
        <CountrySpecificChart />
      </div>
  </div>
</template>
<script>
import MonthlyChart from "@/containers/KSADashboard/MonthlyChart.vue";
import SpecialityChart from "@/containers/KSADashboard/SpecialityChart.vue";
import RankedChart from "@/containers/KSADashboard/RankedChart.vue";
import ApplicationTrendChart from "@/containers/KSADashboard/ApplicationTrendChart.vue";
import CandidateVolumnOTM from "@/containers/KSADashboard/CandidateVolumnOTM.vue";
import ForecastingChart from "@/containers/KSADashboard/ForecastingChart.vue";
import CountrySpecificChart from "@/containers/KSADashboard/CountrySpecificChart.vue";
import GeoChart from "@/components/reusable/Charts/GeoChart.vue";
export default {
  name: "KSADashboard",
  components: {
    MonthlyChart,
    SpecialityChart,
    RankedChart,
    ApplicationTrendChart,
    CandidateVolumnOTM,
    ForecastingChart,
    CountrySpecificChart,
    GeoChart,
  },
};
</script>